<template>
  <base-dialog
    v-model="show"
    max-width="800px"
    min-width="300px"
    scrollable
    :title="title"
    @close="onDialogClose"
    width="60%"
  >
    <object :data="url" width="100%" height="400px" :key="key">
      Not supported
    </object>
  </base-dialog>
</template>
<script>
export default {
  data: () => ({
    show: false,
    url: '',
    title: '',
    key: 1,
  }),
  methods: {
    open(url, title) {
      if (url) {
        this.key = this.key == 1 ? 2 : 1
        this.url = url
        this.title = title
        this.show = true
      }
    },
    onDialogClose() {
      this.show = false
      this.url = ''
      this.title = ''
    },
  },
}
</script>
